export default "__VITE_ASSET__D4VKkOy0__"